/**
 * Modal listing dynamic shipping rate options before Create RMA completes; confirm stays disabled until one is selected.
 */
import { observer } from "mobx-react-lite";
import Currency from "../../../components/currency/currency";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../components/inputs/button-variants";
import { Button } from "../../../components/inputs/button/button";
import { RadioButton } from "../../../components/inputs/radio-button/radio-button";
import { DefaultModalLayout } from "../../../components/modal/layouts/default-modal-layout";
import RmaRequestStore from "../stores/rma-request-store";
import "./create-rma-dynamic-shipping-modal.scss";
import FontHeading3 from "../../../components/fonts/font-heading3/font-heading3";

interface IProps {
	rmaRequestStore?: RmaRequestStore;
}

const CreateRmaDynamicShippingModal: React.FC<IProps> = observer(({ rmaRequestStore }) => {
	if (!rmaRequestStore) {
		return null;
	}
	const radioName = "create-rma-dynamic-shipping-option";
	const dynamicShippingOptionsStore = rmaRequestStore?.dynamicShippingOptionsStore;

	return (
		dynamicShippingOptionsStore.showModal ? (
		<DefaultModalLayout
			isCloseDisabled={false}
			onCloseClicked={() => dynamicShippingOptionsStore.cancelModal()}
			headerContent={
				<div className="create-rma-dynamic-shipping-modal-header-content">
					<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
						Shipping options{/* TODO: Translate */}
					</FontBody1>
				</div>
			}
		>
			<div className="create-rma-dynamic-shipping-modal">
				{dynamicShippingOptionsStore.shippingOptions.length > 0 ? (
				<ul className="create-rma-dynamic-shipping-modal__list">
					{dynamicShippingOptionsStore.shippingOptions.map((option) => (
						<li key={option.id} 
						    className="create-rma-dynamic-shipping-modal__row"
							onClick={() => dynamicShippingOptionsStore.setSelectedOptionId(option.id)}>
								<RadioButton
									name={radioName}
									checked={dynamicShippingOptionsStore.selectedOptionId === option.id}
									onChange={() => dynamicShippingOptionsStore.setSelectedOptionId(option.id)}
								/>
								<div className="create-rma-dynamic-shipping-modal__row-name">
									<FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
										{option.name}
									</FontBody1>
								</div>
								<div className="create-rma-dynamic-shipping-modal__row-description">
									{option.description ? (
										<FontBody1 color={FONT_COLOR.NEUTRAL3}>{option.description}</FontBody1>
									) : null}
								</div>
								<div className="create-rma-dynamic-shipping-modal__row-price-container">
									<div className="create-rma-dynamic-shipping-modal__row-price">
										<FontBody1 color={FONT_COLOR.PRIMARY3}>
											<Currency
												currencyCode={option.currency_code}
												amount={option.cost}
												useNative
											/>
										</FontBody1>
									</div>
								</div>
						</li>
					))}
				</ul>
				) : (
					<div className="create-rma-dynamic-shipping-modal__empty">
						<FontHeading3 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
							No available shipping options{/* TODO: Translate */}
						</FontHeading3>
					</div>
				)}
				<div className="create-rma-dynamic-shipping-modal__buttons">
					<Button
						variant={BUTTON_VARIANTS.Primary}
						text="Continue" // TODO: Translate
						disabled={!dynamicShippingOptionsStore.hasSelection}
						onClick={() => dynamicShippingOptionsStore.confirmSelection()}
					/>
				</div>
			</div>
		</DefaultModalLayout>
		) : null
	);
});

export default CreateRmaDynamicShippingModal;
